import { isValid } from 'date-fns'
import { useScheduleStore } from '@/store/useScheduleStore'
import { appSettings } from '@/shared/consts/appSettings'
import { getFromSessionStorage } from './storageHelpers'

export const getSearchParamsAsObject = (searchParams: URLSearchParams) => {
  return Array.from(searchParams.entries()).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [key]: value
    }),
    {}
  ) as { [key: string]: string }
}

export const buildSearchParamsFromSession = () => {
  const params = getFromSessionStorage('params')
  const searchParams = params
    ? `?${new URLSearchParams(params).toString()}`
    : ''

  return searchParams
}

export const getUtmParamsAsObject = (params: { [key: string]: string }) => {
  const UTM_KEYS = [
    'utm_source',
    'utm_campaign',
    'utm_medium',
    'utm_term',
    'utm_content',
    'utm_id',
    'uid'
  ]

  return UTM_KEYS.reduce(
    (acc, key) => {
      if (params[key]) {
        acc[key] = params[key]
      }
      return acc
    },
    {} as { [key: string]: string }
  )
}

export const buildUrlWithParams = () => {
  const product = useScheduleStore.getState().product
  const location = useScheduleStore.getState().location
  const patient = useScheduleStore.getState().patient
  const doctor = useScheduleStore.getState().doctor
  const healthPlan = useScheduleStore.getInitialState().healthPlan

  const url = new URL(appSettings.publicUrl, window.location.origin)
  const urlWithParams = new URL(url)

  const birthDate =
    patient?.birthDate &&
    isValid(new Date(patient.birthDate)) &&
    new Date(patient.birthDate).toISOString()

  const params = {
    especialidadem: product?.idMotion?.toString(),
    local: location?.id?.toString(),
    pacienteDataNascimento: birthDate,
    pacienteGenero: patient?.gender,
    medicom: doctor?.id?.toString(),
    planordsl: healthPlan?.id?.toString()
  }

  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null) {
      urlWithParams.searchParams.set(key, String(value))
    }
  }

  return encodeURIComponent(urlWithParams.href)
}
